import { prettyDate } from '@/helpers/utils';
import { DATE_FORMAT_DD_MM_YYYY } from '@/helpers/common';
import { EMPTY_DASH } from '@/helpers/constants';
import { DEFAULT_THIS_YEAR_PERIOD } from '@/helpers/date';
import { Chip } from '@/components/TaxReport/Chip';
import { useGetActivityTypes } from '@/query/queries/report/useGetActivityTypes';
import s from './index.module.scss';

export const Chips = ({ params, setParams }) => {
  const { data: activityTypes } = useGetActivityTypes();

  const chips = [];

  // Period chip
  if (params.range.join(':') !== DEFAULT_THIS_YEAR_PERIOD.join(':')) {
    chips.push(
      <Chip
        text={`${prettyDate(params.range[0], DATE_FORMAT_DD_MM_YYYY)} ${EMPTY_DASH} ${prettyDate(params.range[1], DATE_FORMAT_DD_MM_YYYY)}`}
        type="range"
        onClear={() =>
          setParams(prev => ({
            ...prev,
            page: 1,
            range: DEFAULT_THIS_YEAR_PERIOD,
          }))
        }
      />,
    );
  }

  // Operation type chips
  params.operation_types?.map(
    type =>
      activityTypes?.[type] &&
      chips.push(
        <Chip
          key={type}
          text={activityTypes?.[type]}
          type="operation_types"
          onClear={() =>
            setParams(prev => ({
              ...prev,
              page: 1,
              operation_types: prev.operation_types.filter(t => t !== type),
            }))
          }
        />,
      ),
  );

  return chips.length ? <div className={s.chips}>{chips}</div> : null;
};
